import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

class StickyNote extends Component {  
	render() {
    const {text, color, isCompressed, openEditStickyNoteModal} = this.props;
		return (
      <div style={[styles.card, {background: color}, isCompressed && styles.isCompressed]}>
          {isCompressed ? 
            null : <i className="fa fa-pencil waves-icon"
                  aria-hidden="true"
                  onClick={openEditStickyNoteModal}
                  style={styles.editIcon}/>
          }
        <p style={[styles.paragraph,isCompressed && styles.compressedParagraph]}>{text}</p>
      </div>
		);
	}
}

var styles = {
  card: {
    position: 'relative',
    borderRadius: '2px',
    height: '150px',
    fontSize: '12px',
    width: '100%',
    textAlign: 'left',
    padding: '22px 12px 12px 12px',
    zIndex: '1',
    display: 'block',
    marginBottom: '10px'
  },
  isCompressed: {
    height: '25px',
    lineHeight: 'initial',
    padding: '4px 10px',
    textAlign:'center'
  },  
  editIcon: {
    position: 'absolute',
    right: '0px',
    top: '0px',
    fontSize: '18px',
    width: '30px',
    height: '30px',
    lineHeight: '30px',
    cursor: 'pointer'
  },
  paragraph:{
    height: '100%',
    width: '100%',
    whiteSpace: 'pre-line',
    overflow: 'hidden'
  },
  compressedParagraph:{
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
}
  StickyNote.propTypes = {
    id : PropTypes.string.isRequired,
    isCompressed: PropTypes.bool.isRequired,
    color: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  };

export default Radium(StickyNote)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/EmployeeWeekOverview/stickyNote.jsx